export interface StoryViewer {
  id: number;
  username: string;
  avatar: string;
  viewedAt: string;
}

export const MOCK_FOLLOWERS: StoryViewer[] = [
  {
    id: 1,
    username: 'thomas_fitness',
    avatar: 'https://public.readdy.ai/ai/img_res/19c634dd38bf47e3eddd0df9b0bd38e4.jpg',
    viewedAt: 'Il y a 1 min',
  },
  {
    id: 2,
    username: 'sophie_yoga',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20serene%20young%20woman%20with%20long%20hair%20peaceful%20smile%20yoga%20instructor%20look%20clean%20white%20background%20soft%20natural%20lighting%20high%20quality%20photography&width=150&height=150&seq=user3&orientation=squarish',
    viewedAt: 'Il y a 2 min',
  },
  {
    id: 3,
    username: 'alex_cycling',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20athletic%20young%20cyclist%20with%20helmet%20determined%20look%20sporty%20appearance%20clean%20white%20background%20natural%20lighting%20high%20quality%20photography&width=150&height=150&seq=user4&orientation=squarish',
    viewedAt: 'Il y a 4 min',
  },
  {
    id: 4,
    username: 'emma_swimming',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20athletic%20young%20female%20swimmer%20with%20swim%20cap%20confident%20smile%20sporty%20look%20clean%20white%20background%20natural%20lighting%20high%20quality%20photography&width=150&height=150&seq=user5&orientation=squarish',
    viewedAt: 'Il y a 5 min',
  },
  {
    id: 5,
    username: 'lucas_basketball',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20athletic%20young%20basketball%20player%20confident%20expression%20sporty%20appearance%20clean%20white%20background%20natural%20lighting%20high%20quality%20photography&width=150&height=150&seq=user6&orientation=squarish',
    viewedAt: 'Il y a 7 min',
  },
  {
    id: 6,
    username: 'marie_running',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20athletic%20young%20woman%20with%20ponytail%20smiling%20confident%20sporty%20look%20clean%20white%20background%20natural%20lighting%20high%20quality%20photography&width=150&height=150&seq=user1&orientation=squarish',
    viewedAt: 'Il y a 9 min',
  },
  {
    id: 7,
    username: 'julien_tennis',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20athletic%20young%20male%20tennis%20player%20short%20hair%20confident%20look%20sporty%20clean%20white%20background%20studio%20lighting%20high%20quality&width=150&height=150&seq=viewer7&orientation=squarish',
    viewedAt: 'Il y a 11 min',
  },
  {
    id: 8,
    username: 'camille_cross',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20athletic%20young%20woman%20crossfit%20athlete%20strong%20confident%20smile%20clean%20white%20background%20natural%20lighting%20high%20quality%20photography&width=150&height=150&seq=viewer8&orientation=squarish',
    viewedAt: 'Il y a 14 min',
  },
  {
    id: 9,
    username: 'romain_surf',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20young%20male%20surfer%20tanned%20athletic%20casual%20confident%20look%20clean%20white%20background%20natural%20lighting%20high%20quality%20photography&width=150&height=150&seq=viewer9&orientation=squarish',
    viewedAt: 'Il y a 17 min',
  },
  {
    id: 10,
    username: 'noemie_pilates',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20athletic%20young%20woman%20pilates%20instructor%20graceful%20confident%20smile%20clean%20white%20background%20soft%20natural%20lighting%20photography&width=150&height=150&seq=viewer10&orientation=squarish',
    viewedAt: 'Il y a 20 min',
  },
  {
    id: 11,
    username: 'theo_rugby',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20strong%20young%20rugby%20player%20broad%20shoulders%20confident%20smile%20athletic%20clean%20white%20background%20natural%20lighting%20high%20quality&width=150&height=150&seq=viewer11&orientation=squarish',
    viewedAt: 'Il y a 23 min',
  },
  {
    id: 12,
    username: 'lea_triathlon',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20athletic%20female%20triathlete%20determined%20confident%20smile%20sporty%20look%20clean%20white%20background%20natural%20lighting%20high%20quality%20photography&width=150&height=150&seq=viewer12&orientation=squarish',
    viewedAt: 'Il y a 26 min',
  },
];
